<template>
  <one-check v-if="one" v-on="$listeners" v-bind="$attrs"></one-check>
  <more-check v-else v-on="$listeners" v-bind="$attrs"></more-check>
</template>

<script>
import OneCheck from "./one-check";
import MoreCheck from "./more-check";

export default {
  components: {
    OneCheck,
    MoreCheck
  },
  props: {
    one: {
      type: Boolean,
      default: false
    }
  }
};
</script>
